
<div class="col-12 border-l my-2" [ngClass]="[convention?.Ident && convention?.Ident != '0' ? 'main' : 'secondary', client.loading ? 'd-none' : '']" style="background-color: white">
  <!--#region header bloc convention-->
  <input type="checkbox" class="input-button" id="{{client.Ident}}-0-{{convention.Ident}}-{{i}}" [(ngModel)]="convention.displayed" />
  <!-- titre + Etat de la convention -->
  <label for="{{client.Ident}}-0-{{convention.Ident}}-{{i}}"
         class="row pr-0 q-pointer align-items-center"
         placement="auto" [ngbTooltip]="convention.Titre + (convention.CodeEtatDoc == etatDOC.SIGNE ? ' (Validée)' : convention.CodeEtatDoc == etatDOC.ANNULE ? ' (Annulée)' : '')" [disableTooltip]="convention.displayed" container="body"
         [ngClass]="[convention.displayed ? 'py-2' : 'm-0']">

    <ng-container *ngIf="convention.displayed else ConventionHeader">
      <!-- convention avec aucun etatDOC particulier -->
      <ng-container *ngIf="!convention.Ident || convention.Ident == '0' || (convention.CodeEtatDoc != etatDOC.SIGNE && convention.CodeEtatDoc != etatDOC.ANNULE) else WinLoseTitle">
        <h5 class="m-0 col q-bold" *ngIf="!convention.FileExist">Financement</h5>
        <h5 class="m-0 col q-bold" *ngIf="convention.FileExist">Convention</h5>
      </ng-container>
      <ng-template #WinLoseTitle>
        <!-- Afficher si EtatDOC de la convention : Validée ou annulé -->
        <ng-container *ngIf="convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE">
          <h5 class="d-flex m-0 col q-bold"
              [ngClass]="[convention.CodeEtatDoc == etatDOC.SIGNE ? 'q-c-main' : convention.CodeEtatDoc == etatDOC.ANNULE ? 'q-c-danger' : '']">
            <i title="{{convention.CodeEtatDoc}}" class="far mr-2" [ngClass]="[convention.CodeEtatDoc == etatDOC.SIGNE ? 'fa-thumbs-up' : convention.CodeEtatDoc == etatDOC.ANNULE ? 'fa-thumbs-down' : '']"></i>
            {{convention.CodeEtatDoc == etatDOC.SIGNE ? 'Convention validée' : convention.CodeEtatDoc == etatDOC.ANNULE ? 'Convention annulée' : ''}}
            <span *ngIf="convention.Info" class="rounded-button q-dark-secondary ml-2" title="Info: {{convention.Info}}" style="width: fit-content;">{{convention.Info}}</span>
          </h5>
        </ng-container>
      </ng-template>
    </ng-container>
    <ng-template #ConventionHeader>
      <div class="d-flex col align-items-center py-1" *ngIf="convention.FileExist">
        Convention&#8239;n°&#8239;{{convention?.StrNumCvt}}
      </div>
      <div class="d-flex col align-items-center py-1" *ngIf="!convention.FileExist">
        Financement&#8239;n°&#8239;{{convention?.StrNumCvt}}
      </div>
      <div class="d-flex col align-items-center py-1">Montant HT&#8239;: {{convention?.MontantConvention ? convention?.MontantConvention : '0'}}&#8239;{{indParam.AppParams.Devise}}</div>
      <div class="d-flex col align-items-center py-1 q-c-light-black q-bold font-size-13">
        Financeur&#8239;: {{convention?.Financeur?.SocialReason}}
      </div>

      <div class="d-flex col align-items-center py-1" style=" flex-wrap: wrap;">
        Document&#8239;:
        <div>
          <button *ngIf="convention.Ident && convention.Ident !== '0' &&  convention.FileExist" [disabled]="!convention.Ident || convention.Ident == '0'" type="button" class="q-btn-border q-main mx-1" (click)="UploadDoc(convention.Ident, convention.Titre, 'docx')" title="Télécharger la convention au format DOCX"><i class="far fa-file-word"></i></button>
          <button *ngIf="convention.Ident && convention.Ident !== '0' &&  convention.FileExist" [disabled]="!convention.Ident || convention.Ident == '0'" type="button" class="q-btn-border q-main" (click)="UploadDoc(convention.Ident, convention.Titre, 'pdf')" title="Télécharger la convention au format PDF"><i class="far fa-file-pdf"></i></button>

          <i *ngIf="!convention.Ident || convention.Ident == '0' || !convention.FileExist" class="fas fa-times q-c-danger ml-2"></i>
        </div>
      </div>
      <div class="d-flex col align-items-center py-1">
        Facturation&#8239;:
        <i class="mx-2 fas " [ngClass]="[FacturationFont(convention)]"></i>
      </div>
      <div class="d-flex col align-items-center py-1">
        Nb&#8239;Apprenant(s)&#8239;: {{NbApprenants()}}
      </div>
    </ng-template>
    <div class="d-flex col align-self-end justify-content-end align-items-center" style="min-height: 32px;">
      <i class="fas fa-chevron-up chevron"></i>
    </div>
  </label>

  <div class="row accordion-content pt-0" style="flex-wrap: wrap;display: flex;">
    <hr class="col-12 my-0" />
    <div class="col-12 my-2 align-items-center">
      <div class="row ml-0">
        <ng-container *ngIf="client.LinkedToStage else ButtonsClientUnlinked">
          <button class="q-btn q-main" style="height: 35px;"
                  [disabled]="convention.saving || convention.generating || convention.deleting"
                  (click)="OnSave(client, i, false )">
            <i class="fas" [ngClass]="[convention.saving ? 'fa-pulse fa-spin fa-spinner' : 'fa-save']"></i>
          </button>

          <button class="q-btn q-main" style="height: 35px;"
                  [disabled]="convention.saving || convention.generating || convention.deleting || convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE"
                  (click)="OnSave(client, i, true)">
            <i class="fas mr-2" [ngClass]="[convention.generating ? 'fa-pulse fa-spin fa-spinner' : 'fa-print']"></i>
            <span>Générer</span>
          </button>

          <button class="q-btn q-danger" style="height: 35px;"
                  [disabled]="convention.saving || convention.generating || convention.deleting || convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE"
                  (click)="ConfirmDelete(ModalDelete, i)">
            <i class="fas" [ngClass]="[convention.deleting ? 'fa-pulse fa-spin fa-spinner' : 'fa-trash-alt']"></i>
          </button>

          <ng-container *ngIf="convention.Ident && convention.Ident != '0'">
            <button [disabled]="convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE || convention.savingThumb"
                    class="q-btn-border q-success mr-2"
                    title="Convention validée" style="font-size: 1rem; height: 35px;" (click)="OnSaveEtatConvention(client, convention, i, etatDOC.SIGNE)">
              <i [ngClass]="[convention.savingThumb ? 'fas fa-pulse fa-spin fa-spinner' : 'far fa-thumbs-up']"></i>
            </button>
            <button [disabled]="convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE || convention.savingThumb"
                    class="q-btn-border q-danger  mr-2"
                    title="Convention annulée" style="font-size: 1rem; height: 35px;" (click)="OnSaveEtatConvention(client, convention, i, etatDOC.ANNULE)">
              <i [ngClass]="[convention.savingThumb ? 'fas fa-pulse fa-spin fa-spinner' : 'far fa-thumbs-down']"></i>
            </button>

            <button class="q-btn q-success" style="height: 35px;"
                    [disabled]="convention.saving || convention.generating || convention.deleting || convention.savingThumb || convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE"
                    (click)="OpenESignature(ModalESign,convention)"
                    title="Signature électronique de la convention">
              <i class="fas fa-signature"></i>
            </button>
          </ng-container>
        </ng-container>

        <ng-template #ButtonsClientUnlinked>
          <div placement="auto" ngbTooltip="Vérouillé car client non lié au stage" container="body">
            <button class="q-btn q-main" style="height: 35px;" disabled><i class="fas fa-save"></i></button>
            <button class="q-btn q-main" style="height: 35px;" disabled><i class="fas fa-print mr-2"></i><span>Générer</span></button>
            <button class="q-btn q-danger" style="height: 35px;" disabled><i class="fas fa-trash-alt"></i></button>
          </div>
        </ng-template>

        <q-dynamictags-inline #dynamictagsInline
                              *ngIf="convention.Ident != '0' || convention?.DefaultInputs?.length > 0"
                              class="col"
                              [defaultInputs]="convention.Ident != '0' ? [] : convention?.DefaultInputs"
                              [idDonnee]="convention?.Ident" [codeOrIdBo]="'BO_CVT'"
                              [forcedColumnNames]="['Type_DOC', 'tpsalDOC', 'ActivDOC']"
                              [exceptColumnNames]="['TitreDOC', 'Info_DOC', 'NuAccDOC', 'DossiDOC']"></q-dynamictags-inline>


        <button *ngIf="convention?.Ident && convention?.Ident != '0'" class="col-auto btn-icon q-c-light-secondary ml-auto" (click)="openBoConvention(ModalBO, convention)">
          Convention<i class="ml-2 fas fa-edit"></i>
        </button>
      </div>
    </div>
    <!--#endregion-->
    <!--#region financeur-->
    <div class="col-12 my-1">
      <div class="row align-items-center">
        <div class="col-12 col-lg-auto"><div class="q-c-light-black q-bold font-size-13">Financeur</div></div>
        <div style="width: 450px;max-width: 100%;">
          <q-autosearch Mode="CLIENTONLY" CustomClass="q-input-no-border q-c-light-black q-bold"
                        placeholder="Si différent du donneur d'ordre"
                        [InputText]="convention?.Financeur?.SocialReason"
                        (SetInput)="ChangeFinanceur(client, convention, $event)"></q-autosearch>
        </div>
        <div class="mx-1" title="Gestion du financeur">
          <ng-container *ngIf="client.LinkedToStage">
            <!-- Recherche avancée -->
            <button class="col-auto btn-icon q-btn q-c-light-secondary" title="Recherche avancée du financeur" (click)="openBoFindFinanceur(ModalBOFindFinanceur)">Recherche avancée </button>
            <!-- Création d'un financeur -->
            <button class="col-auto btn-icon q-btn q-c-light-secondary" title="Création d'un nouveau financeur'" (click)="openBoFinanceur(ModalBOFinanceur)">Créer un financeur</button>
          </ng-container>
        </div>
        <div class="col-12 col-lg-auto"><div class="q-c-light-black q-bold font-size-13">Entité de facturation</div></div>
        <div class="col-12 col-sm-auto">
          <select class="q-main-select" style="max-width: 100%;" [(ngModel)]="convention.IdEntiteFact" [disabled]="convention?.IdEntiteFactProfil!=''" required>
            <option value="">- - - - -</option>
            <option *ngFor="let entite of EntiteFact" [value]="entite.Value">{{entite.Text}}</option>
          </select>
        </div>
      </div>
    </div>
    <!--#endregion-->
    <!--#region bloc de gauche-->
    <div class="col-lg-12 col-xl m-1 field-select">
      <!--#region bloc saisis-->
      <div class="col-12 pr-1 " [ngClass]="convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE ? 'field-select q-light-grey' : 'mb-2'">

        <!--#region documentdocument innexistante-->
        <ng-container *ngIf="!convention.generating else GeneratingDoc">
          <div *ngIf="!convention.Ident || convention.Ident == '0'" class="col-12 row align-items-end">
            <div class="col-12">
              <div class="row w-100 text-center q-nodata q-c-main"><i class="fas fa-exclamation-circle mr-2" style="align-self: center;"></i>La convention n'a pas encore été créée</div>
            </div>
          </div>
          <!--#endregion-->
          <!--#region données du convention-->
          <div *ngIf="convention.Ident && convention.Ident !== '0'" class="col-12 row align-items-end">

            <div class="col-12 col-md-7">
              <div class="row align-items-baseline">
                <i class="mr-2" [ngClass]="convention.CodeEtatDoc == etatDOC.SIGNE ? 'fas fa-signature q-c-success' : convention.CodeEtatDoc == etatDOC.ANNULE ? 'far fa-thumbs-down q-c-danger' : '' " title="{{convention.Info}}"></i>
                <strong class="q-c-main mr-2">{{convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE ? convention.Titre : convention.FileExist ? ' Convention ': ' Financement '}}</strong>
                <small class="mr-2"> n°{{convention.StrNumCvt}} du {{convention.StrDateCreation}}</small>
                <strong class="mr-2" [ngClass]="convention.CodeEtatDoc == etatDOC.SIGNE ? 'q-c-success' : 'q-c-danger'">{{convention.CodeEtatDoc == etatDOC.SIGNE ? 'validée' : convention.CodeEtatDoc == etatDOC.ANNULE ? 'annulée' : '' }}</strong>
                <small>{{convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE ? ' le ' : '' }}{{convention.CodeEtatDoc == etatDOC.SIGNE ? convention.StrDateSignature : convention.CodeEtatDoc == etatDOC.ANNULE ? convention.StrDatePerdu : ''}}</small>
              </div>
              <div class="row" *ngIf="convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE">
                <small><strong>N° d'accord:</strong> {{convention.NumAccord}}</small>
              </div>
            </div>

            <div *ngIf="convention.Ident && convention.Ident !== '0' && !convention.FileExist" class="col-12 col-md-4 p-0 q-nodata q-c-main">
              <i class="fas fa-exclamation-circle" style="align-self: center;"></i>
              Document non généré
            </div>

            <!--#region boutons de téléchargement/modification du document physique-->
            <div class="col-auto ml-auto p-0">
              <button *ngIf="convention.Ident && convention.Ident !== '0' &&  convention.FileExist" [disabled]="!convention.Ident || convention.Ident == '0'" type="button" class="q-btn-border q-main" (click)="UploadDoc(convention.Ident, convention.Titre, 'docx')" title="Télécharger la convention au format DOCX"><i class="far fa-file-word"></i></button>
              <button *ngIf="convention.Ident && convention.Ident !== '0' &&  convention.FileExist" [disabled]="!convention.Ident || convention.Ident == '0'" type="button" class="q-btn-border q-main" (click)="UploadDoc(convention.Ident, convention.Titre, 'pdf')" title="Télécharger la convention au format PDF"><i class="far fa-file-pdf"></i></button>
              <button [disabled]="!convention.Ident || convention.Ident == '0'" type="button" class="q-btn-border q-main" (click)="openUploadDocument(ModalUploadDocument, convention)" title="Transférer la convention modifiée"><i class="fas fa-download"></i></button>
            </div>
            <!--#endregion-->
          </div>
        </ng-container>
        <ng-template #GeneratingDoc>
          <div class="col-12 row align-items-end">
            <div class="col-12">
              <div class="row w-100 text-center q-nodata q-c-main"><i class="fas fa-spinner fa-pulse mr-2" style="align-self: center;"></i>Génération de la convention</div>
            </div>
          </div>
        </ng-template>
        <!--#endregion-->
        <!--#region inputs-->
        <div class="col-12 row" *ngIf="convention.CodeEtatDoc != etatDOC.SIGNE && convention.CodeEtatDoc != etatDOC.ANNULE">
          <div class="q-c-light-black q-bold font-size-13 mt-2 mb-0">Titre{{convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE ? ' : ' : ''}}</div>
          <span *ngIf="convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE else InputTitre" class="ml-1 q-c-light-black font-size-13 mt-2 mb-0">{{convention.Titre}}</span>
          <ng-template #InputTitre><input type="text" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="convention.Titre"></ng-template>
        </div>
        <div class="col-12 row" *ngIf="convention.CodeEtatDoc != etatDOC.SIGNE && convention.CodeEtatDoc != etatDOC.ANNULE">
          <div class="q-c-light-black q-bold font-size-13 mt-2 mb-0">Info{{convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE ? ' : ' : ''}}</div>
          <span *ngIf="convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE else InputInfo" class="ml-1 q-c-light-black font-size-13 mt-2 mb-0">{{convention.Info}}</span>
          <ng-template #InputInfo><input type="text" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="convention.Info"></ng-template>
        </div>
        <div class="col-12 row" *ngIf="convention.CodeEtatDoc != etatDOC.SIGNE && convention.CodeEtatDoc != etatDOC.ANNULE">
          <div class="q-c-light-black q-bold font-size-13 mt-2 mb-0">N° d'accord</div>
          <span *ngIf="convention.CodeEtatDoc == etatDOC.SIGNE || convention.CodeEtatDoc == etatDOC.ANNULE else InputNumAccord" class="ml-1 q-c-light-black font-size-13 mt-2 mb-0">{{convention.NumAccord}}</span>
          <ng-template #InputNumAccord><input type="text" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="convention.NumAccord"></ng-template>
        </div>
        <!--#endregion-->
      </div>
      <!--#endregion-->
      <!--#region listes des relations-->
      <div class="col-12  mt-1 px-0 px-sm-2 px-md-4">
        <div class="col-12 row mx-0">
          <div class="list-container" style="font-size: 12px;">
            <ng-container *ngTemplateOutlet="liste; context:{code: 'STAGE', title: 'Stages', addBtn: false, titleHeader: 'Choisir les stages', textAucun: 'Aucun stage à ajouter', convention: convention, list: convention.Stages}"></ng-container>
          </div>
          <div class="list-container" style="font-size: 12px;">
            <ng-container *ngTemplateOutlet="liste; context:{code: 'APPRENANT', title: 'Apprenants', addBtn: false, titleHeader: 'Choisir les apprenants', textAucun: 'Aucun apprenant à ajouter', convention: convention, list: convention.Apprenants}"></ng-container>
          </div>
          <div class="list-container" style="font-size: 12px;">
            <ng-container *ngTemplateOutlet="liste; context:{code: 'RESPONSABLE', title: 'Responsable inscription', addBtn: true, titleHeader: 'Choisir le responsable inscription', textAucun: 'Aucun responsable inscription à ajouter', convention: convention, list: convention.Responsables}"></ng-container>
          </div>
        </div>
      </div>
      <!--#endregion-->
    </div>
    <!--#endregion-->
    <!--#region bloc de droite-->
    <div class="col-lg-12 col-xl-auto my-1">
      <!--#region montants-->
      <div class="field-select">
        <div class="row my-1 q-card justify-content-center">

          <button class="q-btn q-c-main q-pointer col-5"
                  style="height: 45px;"
                  (click)="OpenFact(client, convention, convention?.Ident, client?.Ident, 'REL_BO_CSOC_BO_CVT', 1);"
                  title="Facturation"
                  [disabled]="!convention || !convention.Ident || convention.Ident == '0' || convention.EntiteLock">
            <div class="row no-gutters">
              <div class="col-3" style="display: flex; align-items: center;">
                <i class="fas fa-money-bill fa-stack-2x"></i>
                <i class="fas fa-circle fa-stack-1x"></i>
                <i class="fas fa-forward fa-stack-1x" style="color: white;"></i>
              </div>
              <div class="col-9">
                <span>Facturation manuelle</span>
              </div>
            </div>

          </button>

          <button class="q-btn q-c-main q-pointer col-5"
                  style="height: 45px;"
                  (click)="OpenFact(client, convention, convention?.Ident, client?.Ident, 'REL_BO_CSOC_BO_CVT', 0);"
                  title="Facturation par échéancier"
                  [disabled]="!convention || !convention.Ident || convention.Ident == '0' || convention.EntiteLock">
            <div class="row no-gutters">
              <div class="col-3" style="display: flex; align-items: center;">
                <i class="fas fa-money-bill fa-stack-2x"></i>
              </div>
              <div class="col-7">
                <span>Facture par échéancier</span>
              </div>
              <div class="col-2" style="display: flex; align-items: center;">
                <i class="ml-1 fas " [ngClass]="[FacturationEcheancierFont(convention)]"></i>
              </div>
            </div>
          </button>

        </div>

        <div class="row my-1 q-card">
          <div class="col-6 p-0" style="text-align: center;">
            <div class="col-12 q-bold q-text-xl">Convention :</div>
            <span class="col-12">Montant HT : {{convention?.MontantConvention | money}}</span>
          </div>
          <div class="col-6 p-0">
            <button class="q-btn q-c-main  q-pointer" style="height: 45px;"
                    title="Facturation automatique ; indisponible en cas de convention multi-stages ou lignes de facture existantes"
                    [disabled]="DisabledGenerationAuto(convention) || convention.EntiteLock" (click)="GenerateLigneFacture(client, convention, i)">
              <div class="row no-gutters">
                <div class="col-3" style="display: flex; align-items: center;">
                  <i class="fas fa-stack-2x" [ngClass]="convention.generatingFact ? 'fa-spin fa-spinner fa-pulse' : 'fa-money-bill-alt'"></i>
                </div>
                <div class="col-9">
                  <span>Facturation automatique</span>
                </div>
              </div>
            </button>
          </div>

        </div>

        <div class="row my-1 q-card q-light-grey text-center">
          <div class="col-12 q-bold q-text-xl">Facture(s) :</div>
          <!--<div class="col-12 mb-2" *ngIf="convention?.MontantFactureHt && convention?.MontantFactureTTC else EmptyMontantFacture">HT : {{convention?.MontantFactureHt ? convention?.MontantFactureHt : '0'}}&#8239;{{indParam.AppParams.Devise}} - TTC : {{convention?.MontantFactureTTC ? convention?.MontantFactureTTC : '0'}}&#8239;{{indParam.AppParams.Devise}}</div>-->
          <!--<ng-template #EmptyMontantFacture><div class="col-12 mb-2">0&#8239;{{indParam.AppParams.Devise}}</div></ng-template>-->
          <table class="w-100" *ngIf="convention?.Factures?.length > 0">
            <thead>
              <tr>
                <th>Facture n°</th>
                <th>TTC</th>
                <th>Restant dû</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let facture of convention?.Factures" style="border-top: 1px solid var(--c-light-black);">
                <td>{{facture?.StrNumFacture ? facture?.StrNumFacture : 'En préparation'}}</td>
                <td class="py-1" style="text-align: end;">{{facture?.MontantTTC ? facture?.MontantTTC : '0'}}&#8239;{{indParam.AppParams.Devise}}</td>
                <td class="py-1" style="text-align: end;">{{facture?.RestantDu ? facture?.RestantDu : '0'}}&#8239;{{indParam.AppParams.Devise}}</td>
                <td class="py-1" style="text-align: end;">
                  <i *ngIf="facture?.StrNumFacture" class="far fa-file-pdf q-c-danger fa-2x q-pointer" (click)="UploadDoc(facture.Ident, facture?.StrNumFacture, 'pdf')" title="Télecharger la facture au format PDF"></i>
                  <i *ngIf="!facture?.StrNumFacture && !convention.EntiteLock" class="fas fa-external-link-alt q-c-main fa-lg q-pointer" (click)="OpenLigneFact(client, convention, facture.Ident)" title="Modifier la facture"></i>
                </td>
              </tr>
            </tbody>
            <tfoot *ngIf="convention?.Factures && convention?.Factures.length > 1" class="q-bold">
              <tr style="border-top: 1px solid var(--c-light-black);">
                <td style="text-align: end;">Totaux</td>
                <td class="py-1" style="text-align: end;">{{SummMtFact(convention.Factures, 'MontantTTC')}}&#8239;{{indParam.AppParams.Devise}}</td>
                <td class="py-1" style="text-align: end;">{{SummMtFact(convention.Factures, 'RestantDu')}}&#8239;{{indParam.AppParams.Devise}}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
          <!--<div class="col-12" *ngIf="!convention ||!convention.Factures || convention.Factures.length == 0">0&#8239;{{indParam.AppParams.Devise}}</div>-->
        </div>
      </div>
      <!--#endregion-->
    </div>
    <!--#endregion-->
  </div>
</div>

<!-- Upload du devis -->
<ng-template #ModalUploadDocument let-modalUploadDocument>
  <div class="modal-header">
    <h5 class="modal-title" id="uploadDocumentModalLongTitle"></h5>
    <button type="button" class="close" aria-label="Close" (click)="modalUploadDocument.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <q-insertdoc class="h-100 w-100" boHidden [item]="insertDocModel" [registerMode]="'UPLOADDOCWOLINK'" (success)="modalUploadDocument.close('SAVE')"></q-insertdoc>
  </div>
</ng-template>

<ng-template #liste let-title="title" let-titleHeader="titleHeader" let-addBtn="addBtn" let-textAucun="textAucun" let-convention="convention" let-list="list" let-code="code">

  <!--add Contact-->
  <div class="w-100 pl-0 mt-2 mb-1">
    <button type="button" class="q-btn-border q-main" title="Ajouter des {{title}}" #pophover="ngbPopover" [ngbPopover]="popCntContent" [popoverTitle]="popCntTitle" placement="auto" container="body" popoverClass="q-popover h-50-vh" [autoClose]="'outside'">
      <span class="pl-1">{{title}}</span>
      <i class="fas fa-plus float-right p-1"></i>
    </button>

  </div>
  <!--list Contact-->
  <div *ngIf="convention && CheckList(list)" class="col-12 py-1 q-zone-participant">
    <div class="row">
      <button *ngIf="code == 'APPRENANT'" id="uncheckAll" class="q-btn-border q-danger mx-1" (click)="RemoveAllApprenants()">Retirer tous</button>
    </div>
    <ng-container *ngFor="let cnt of list">
      <ng-container *ngIf="cnt.Selected">
        <div class="row q-line-user px-2">
          <span class="q-line-user-text" [title]="(cnt.Civilite ? cnt.Civilite + ' ' : '') + cnt.Text">
            {{cnt.Civilite ? cnt.Civilite + ' ' : ''}}{{cnt.Text}}
            <i class="fas fa-exclamation-triangle q-c-warning q-warning-apprenant pl-1" title="Cet apprenant n'est plus sur le client {{client.RaisoCli}}" *ngIf="code == 'APPRENANT' && !cnt.ApprenantOnClient"></i>
            <i class="fas fa-exclamation-triangle q-c-warning q-warning-apprenant pl-1" title="Cet apprenant n'est pas sur le stage n°{{stageService.Stage.NumStage}}" *ngIf="code == 'APPRENANT' && !cnt.ApprenantOnStage"></i>
            <i class="fas fa-info-circle q-c-main q-warning-apprenant pl-1" title="{{cnt.TxtStageApprenant}}" *ngIf="code == 'APPRENANT' && cnt.TxtStageApprenant && cnt.TxtStageApprenant.length > 0"></i>
          </span>
          <span class="fa-stack fa-xs q-c-danger q-btn-partdelete float-right ml-auto" title="retirer {{title}}" (click)="RemoveElementList(cnt, code)">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fas fa-trash-alt fa-stack-1x fa-inverse" title="Retirer {{cnt.Text}}"></i>
          </span>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <ng-template #popCntTitle> {{titleHeader}}</ng-template>
  <ng-template #popCntContent>
    <ng-container *ngIf="CheckList(list, false)">
      <div class="p-2" style="max-height: 50vh;overflow: auto;">

        <button *ngIf="code == 'APPRENANT'" id="checkAll" class="q-btn-border q-main" (click)="AddAllApprenants()">Ajouter tous</button>
        <ng-container *ngFor="let cnt of list">
          <ng-container *ngIf="!cnt.Selected">
            <div class="q-hover" style="white-space: nowrap;" (click)="AddElementList(cnt, code)">
              <span class="mx-2">
                {{cnt.Text}}
              </span>
            </div>
            <hr class="m-0" />
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="!CheckList(list,false)">
      {{textAucun}}

    </ng-container>
    <div>
      <button *ngIf="addBtn" title="Création d'un responsable d'inscription" class="col-auto btn-icon q-btn q-c-light-secondary m-2" (click)="openBoRespInscription(ModalBORespInscription);pophover.close()">Créer</button>
    </div>
  </ng-template>
</ng-template>

<!-- Modals BO -->
<ng-template #ModalBO class="modal-dialog-centered" let-modalBO>
  <div class="p-4">
    <button type="button" class="close d-flex justify-content-end" (click)="modalBO.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
    <q-bodisplay class="w-100 h-100 mb-5" [item]="modelBOConvention" (sendEvent)="OnSaveBo($event); modalBO.close('SAVE')"></q-bodisplay>
  </div>
</ng-template>

<!-- Modals BO -->
<ng-template #ModalDelete class="modal-dialog-centered" let-modalDelete>
  <div class="modal-header">
    <button type="button" class="close d-flex justify-content-end" (click)="modalDelete.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class=" row">
      <p class="col-12 q-c-main q-bold q-text-l" style="text-align: center;">Confirmer la suppression de la convention {{convention.Titre}}</p>
      <button class="q-btn q-danger col-auto ml-auto mt-4" aria-label="Close" (click)="modalDelete.dismiss();">Annuler</button>
      <button class="q-btn q-main col-auto mt-4"
              [disabled]="convention.saving || convention.generating || convention.deleting"
              (click)="OnDelete(modalDelete)">
        <i class="fas mr-2" [ngClass]="[convention.deleting ? 'fa-pulse fa-spin fa-spinner' : 'fa-trash-alt']"></i>Valider la suppression
      </button>
    </div>

  </div>
</ng-template>

<!-- Modals BO Financeur -->
<ng-template #ModalBOFinanceur class="modal-dialog-centered" let-modalBOFinanceur>
  <div class="modal_content">
    <div class="modal-header">
      <div class="col-11 q-text-xl q-c-main">Création d'un financeur</div>
      <div class="col-auto d-flex justify-content-end">
        <button type="button" class="close" (click)="modalBOFinanceur.close('CANCEL')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="p-4">
      <q-bodisplay class="w-100 h-100 mb-5" [item]="modelBOFinanceur" (sendEvent)="OnSaveBo($event); modalBOFinanceur.close('SAVE')"></q-bodisplay>
    </div>
  </div>
</ng-template>

<!-- Modals BO Responsables d'inscriptions -->
<ng-template #ModalBORespInscription class="modal-dialog-centered" let-modalBORespInscription>
  <div class="modal_content">
    <div class="modal-header">
      <div class="col-11 q-text-xl q-c-main">Création d'un responsable inscription</div>
      <div class="col-auto d-flex justify-content-end">
        <button type="button" class="close" (click)="modalBORespInscription.close('CANCEL')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="p-4">
      <q-bodisplay class="w-100 h-100 mb-5" [item]="modelBORespInscription" (sendEvent)="OnSaveBoResponsable($event); modalBORespInscription.close('SAVE')"></q-bodisplay>
    </div>
  </div>
</ng-template>

<!-- Modals BO-find pour chercher les financeurs -->
<ng-template #ModalBOFindFinanceur class="modal-dialog-centered" let-modalBOFindFinanceur>
  <div class="modal_content">
    <div class="modal-header d-flex justify-content-end">
      <div class="col-11 q-text-xl q-c-main">Recherche avancée d'un financeur</div>
      <button type="button" class="close" (click)="modalBOFindFinanceur.close('CANCEL')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="mt-3">
      <q-search [idBo]="modelBORechercheFinanceur.IdentBO" [codeRelation]="modelBORechercheFinanceur.IdRelation" [idPere]="modelBORechercheFinanceur.IdDonneePere" [multiBo]="false" [selectSingle]="true" [modelForLink]="modelForQSearch" (sendListIdentValue)="GetListFinanceur($event)" (success)="modalBOFindFinanceur.close('SAVE')"></q-search>
    </div>
  </div>
</ng-template>


<!-- Modals E-Signe pour signer electroniquement la convention -->
<ng-template #ModalESign class="modal-dialog-centered" let-modalESignature>
  <div class="modal_content">
    <div class="modal-header d-flex justify-content-end">
      <button type="button" class="close" (click)="modalESignature.close('CANCEL')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <q-esignature [(idBO)]="boConvention" [(idDonnee)]="idConvention" [(signMode)]="mode"></q-esignature>
  </div>
</ng-template>
